import { render, staticRenderFns } from "./badd.vue?vue&type=template&id=691a5d7c&scoped=true&"
import script from "./badd.vue?vue&type=script&lang=js&"
export * from "./badd.vue?vue&type=script&lang=js&"
import style0 from "./badd.vue?vue&type=style&index=0&id=691a5d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691a5d7c",
  null
  
)

export default component.exports